export default "__VITE_ASSET__a0aef848__"